<template>
  <el-cascader
    v-model="value"
    class="smart-cascader"
    :options="optionsTree"
    :show-all-levels="false"
    :change-on-select="!onlySelectLeaf"
    :clearable="true"
    :disabled="disabled"
    @change="changeValue">
  </el-cascader>
</template>

<script>
import { treeFormat } from '@/utils/common'

function treeValue (result, cid, options) {
  if (cid !== undefined && cid !== '') {
    const pid = options.find(option => option.value === cid).parentId
    if (pid) {
      return treeValue([cid, ...result], pid, options)
    } else {
      return [cid, ...result]
    }
  } else {
    return result
  }
}

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    live: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    dataType: {
      type: String,
      default: 'string'
    },
    currentValue: {
      type: String | Number
    },
    onlySelectLeaf: {
      type: Boolean,
      default: true
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      value: treeValue([], this.currentValue, this.options)
    }
  },
  computed: {
    optionsTree () {
      return treeFormat(this.options, 'value')
    }
    // value: {
    //   get () {
    //     return treeValue([], this.currentValue, this.options)
    //   },
    //   set (value) {
    //     this.$emit('input', value[value.length - 1])
    //   }
    // }
  },
  methods: {
    changeValue (value) {
      this.$emit('input', value[value.length - 1])
      this.$emit('changeValue', value[value.length - 1])
    }
  }
}
</script>
<style scope lang="sass">
.smart-cascader
  width: 100%
  .el-input__icon
    width: 40px
    height: 38px
    right: 1px
    top: 1px
    padding: 4px 8px
    color: #999
    // :after
    //   height: 30px
  .el-input__inner
    color: #35495e
    border: 1px solid #e8e8e8
    padding-left: 14px
  .el-cascader__label
    padding-left: 14px
</style>



// WEBPACK FOOTER //
// SmartCascader.vue?e4263366